"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var CalendarArrow = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 8 13", fill: "currentColor", width: size || '8', height: size || '13' }, props),
        React.createElement("path", { d: "M 8.01 6.19C 8.01 6.19 0.98 13.01 0.98 13.01 0.98 13.01-0.01 12.05-0.01 12.05-0.01 12.05 5.92 6.29 5.92 6.29 5.92 6.29 0 0.97 0 0.97 0 0.97 1 0.01 1 0.01 1 0.01 6.91 5.33 6.91 5.33 6.91 5.33 7.01 5.23 7.01 5.23 7.01 5.23 8.01 6.19 8.01 6.19Z", fill: "currentColor" })));
};
CalendarArrow.displayName = 'CalendarArrow';
exports.default = CalendarArrow;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CalendarArrow.js.map